(function () {
  "use strict";

  angular.module("UnknownNetworks")
    .controller("UnknownNetworksController", [
        '$scope', '$filter', 'toastr', 'EventHandlerService', 'currentTenant',
        '$http', '$window', 'UnknownNetworkListPaging', 'EventServiceEvents', '$timeout',
        'WorkstationListPaging', 'WorkstationListService', 'TEMPLATE_PATHS', '$ngBootbox',
        'uuid',
        function (
          $scope, $filter, toastr, EventHandlerService, currentTenant,
          $http, $window, UnknownNetworkListPaging, EventServiceEvents, $timeout,
          WorkstationListPaging, WorkstationListService, TEMPLATE_PATHS, $ngBootbox,
          uuid) {

          $scope.tenant = currentTenant;
          $scope.windowWidth = $window.innerWidth;
          $scope.unknownNetworkListPaging = new UnknownNetworkListPaging();
          $scope.loadingPage = true;

          $scope.helpCaption = 'HelpUnknownNetworksPage';

          var scrollEnd = null;
          var containerHeight = null;


          (function(){
            initEventHandler();
            getUnknownNetworkStatus();
            bindPageScroll();
          })();

          function reportWindowSize() {
            $scope.windowWidth = $window.innerWidth;
            $scope.$apply();
          }
          window.onresize = reportWindowSize;

          function initEventHandler() {
            EventHandlerService.deRegisterListeners();
          };

          function getUnknownNetworkStatus () {
            var url = $scope.tenant.info._links['px:unknownNetworksStatus'].href;

            $http.get(url).then(function(response) {
              checkUnknownNetworkStatus(response.data);
            }).catch(function(error) {
              console.log(error);
            });
          }

          // MAKE SOLID SET OF RULES FOR buildStatus
          function checkUnknownNetworkStatus (buildStatus) {

            if (buildStatus.rebuildStarted) {
              var buildStart = new Date(buildStatus.rebuildStarted).getTime();
              var currentTime = new Date().getTime();
              var difference = currentTime - buildStart;

              if (difference > 7200000) {
                buildUnknownNetworks(buildStatus);
              }
            }

            if (!buildStatus.rebuildStarted  ) {
              buildUnknownNetworks(buildStatus);
            }

            if (buildStatus.buildTime && !buildStatus.rebuildStarted) {
              getUnknownNetworksFirstPage();
            }
          }

          function buildUnknownNetworks (buildStatus) {
            var url = buildStatus._links['px:rebuild'].href;

            $http.get(url).then(function(response) {
            }).catch(function(error) {
              console.log(error);
            });

          }

          $scope.refreshUnknownNetworks = function () {
            getUnknownNetworksFirstPage();
          }

          function getUnknownNetworksFirstPage () {
            $scope.loadingPage = true;
            $scope.unknownNetworkListPaging.pagingCriteria.page = 0;
            var url = $scope.tenant.info._links['px:unknownNetworks2'].href  + $scope.unknownNetworkListPaging.getPagedUrlParameters();
            $http.get(url).then(function(response) {
              angular.element('.unknown-network-list').scrollTop(0);

              $scope.loadingPage = false;
              $scope.totalPages = response.data.page.totalPages;
              if (response.data._embedded) {
                $scope.unknownNetworksList  = addUrlID(response.data._embedded['px:unknownNetworkResources']);
              } else {
                $scope.unknownNetworksList = []
              }
            }).catch(function(error) {
            });
          }

          function addUrlID (unknownNetworksList){
            angular.forEach(unknownNetworksList, function (network) {
              network.urlID = JSON.stringify(network)
              network.customProperties = {
                id: uuid.v4()
              }

            })
            return unknownNetworksList;
          }

          $scope.refreshUnknownNetworks = function () {
            getUnknownNetworksFirstPage();
          }

          function getNextPage () {
            if (!$scope.loadingPage && $scope.totalPages > $scope.unknownNetworkListPaging.pagingCriteria.page + 1) {
              $scope.loadingPage = true;
              $scope.unknownNetworkListPaging.pagingCriteria.page += 1;
              var url = $scope.tenant.info._links['px:unknownNetworks2'].href  + $scope.unknownNetworkListPaging.getPagedUrlParameters();

              $http.get(url).then(function(response) {
                $scope.loadingPage = false;
                if (response.data._embedded) {
                  $scope.unknownNetworksList  = $scope.unknownNetworksList.concat(addUrlID(response.data._embedded['px:unknownNetworkResources']));
                } else {
                  $scope.unknownNetworksList = []
                }
              }).catch(function(error) {
              });
            }
          }

          function bindPageScroll() {
            $timeout(function  () {
              angular.element('.unknown-network-list').on('scroll', function (event) {
                scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
                containerHeight = event.currentTarget.scrollHeight;
                if (!$scope.loadingPage && $scope.totalPages > $scope.unknownNetworkListPaging.pagingCriteria.page + 1) {
                  if (scrollEnd > containerHeight) {
                    $timeout(function() {
                      getNextPage();
                    }, 300)
                  }
                }
              });
            },100)
          }

        function showUnknownNetworkInfo (gateway) {
          $scope.gateway = gateway;
          var workstationListPaging = new WorkstationListPaging();
          workstationListPaging.pagingCriteria.gateway = $scope.gateway;
          WorkstationListService.getWorkstationListPaged(workstationListPaging).then(function(workstationContainer) {
            $scope.workstationContainer = workstationContainer;
            var unknownNetworkDialogOptions = {
              scope: $scope,
              templateUrl: TEMPLATE_PATHS.UNKNOWN_NETWORK_INFO_TEMPLATE_PATH,
              buttons: {
                success: {
                  className: "btn-primary",
                  label: $filter("translate")("Ok")
                }
              }
            };
            $ngBootbox.customDialog(unknownNetworkDialogOptions);
          }).catch(function(error) {
          });
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // LIST MENU
        ////////////////////////////////////////////
        $scope.openListMenu = function (event, network) {
          var position = document.getElementById(event.target.id).getBoundingClientRect();
          $timeout(function () {
            $scope.closeListMenu();
            $scope.listMenuContext = network;
            $scope.listMeta = {
              position: {left: position.x, top: position.y},
              parentId: event.target.id,
              type: 'unknownNetworkList',
              scrollContainerId: 'NetworkScrollContainer'
            }
            $scope.$apply();
          }, 50)
        }

        $scope.closeListMenu = function (network, action) {
          bindPageScroll();
          $scope.listMenuContext = null;
          $scope.listMeta = null;

          switch (action) {
            case 'SHOW_INFO':
              showUnknownNetworkInfo(network);
            break;
          }
        }

          $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.UNKNOWN_NETWORK_LIST_BUILT, function () {
            if (!$scope.unknownNetworksList) {
              getUnknownNetworksFirstPage();
            }
          });


      }]);
})();